import React from 'react';
import './HeroSection.css';

export default function HeroSection() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero">
      <div className="hero-grain" />
      <div className="container">
        <div className="row align-items-center g-5">

          {/* ── Left ── */}
          <div className="col-lg-6">
            <div className="hero-badge">
              <i className="bi bi-stars"></i> AI-Powered Agricultural Intelligence
            </div>
            <h1 className="hero-title mb-4">
              Detect Crop<br />
              Diseases <span className="accent">Early.</span><br />
              Save <span className="gold">More Yield.</span>
            </h1>
            <p className="hero-sub mb-5">
              Take a photo of your tomato or maize leaf and let our advanced AI identify diseases
              in under 2 seconds — with instant diagnosis, confidence scores, and expert treatment plans.
              No agronomist needed. Free for every farmer.
            </p>
            <div className="hero-btns d-flex flex-wrap gap-3">
              <button className="btn-primary-green pulse" onClick={() => go('detect')}>
                <i className="bi bi-camera"></i>Scan Your Crop Now
              </button>
              <button className="btn-outline-green" onClick={() => go('how-it-works')}>
                <i className="bi bi-play-circle"></i>See How It Works
              </button>
            </div>
          </div>

          {/* ── Right Card ── */}
          <div className="col-lg-6">
            <div className="hero-card">
              <div className="hero-card-img">🌿</div>
              <div className="row g-3">
                <div className="col-4">
                  <div className="hero-stat">
                    <div className="num">98%</div>
                    <div className="lbl">Accuracy</div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="hero-stat">
                    <div className="num">2s</div>
                    <div className="lbl">Detection Time</div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="hero-stat">
                    <div className="num">15+</div>
                    <div className="lbl">Diseases</div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="latest-detect">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span style={{ fontSize: '.82rem', color: 'var(--text-muted)' }}>Latest Detection</span>
                      <span style={{ fontSize: '.75rem', background: 'rgba(82,183,136,.15)', color: 'var(--green-accent)', padding: '3px 10px', borderRadius: '50px', border: '1px solid rgba(82,183,136,.3)' }}>
                        ✓ Healthy
                      </span>
                    </div>
                    <div style={{ fontSize: '.88rem', color: 'var(--cream)' }}>Tomato Leaf — No Disease Detected</div>
                    <div style={{ fontSize: '.78rem', color: 'var(--text-muted)', marginTop: 4 }}>
                      Confidence: 96.4% &nbsp;·&nbsp; 2 minutes ago
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
